import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FileBase from 'react-file-base64';

function AccountSettings() {
    const [responseData, setResponseData] = useState({});
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [image, setImage] = useState("");
    const [fileName, setFileName] = useState("");
    const [isLoading, setIsLoading] = useState(false); // State for managing the loading overlay

    const id = localStorage.getItem("userId");
    const navigate = useNavigate();

    useEffect(() => {
        const getUserData = async () => {
            const url = `${process.env.REACT_APP_BACKEND_URL}/api/v2/admin/get/${id}`;
            const response = await axios.get(url);
            setResponseData(response.data.admin);
        };
        getUserData();
    }, [id]);

    useEffect(() => {
        if (responseData) {
            setFirstName(responseData.firstName || "");
            setLastName(responseData.lastName || "");
            setImage(responseData.image || "");

            // Set file name from local storage or use a default name if image exists
            const storedFileName = localStorage.getItem("fileName");
            setFileName(storedFileName || (responseData.image ? "current_image.png" : ""));
        }
    }, [responseData]);

    const updateUserDetails = async () => {
        setIsLoading(true); // Show the loading overlay
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v2/admin/update/${id}`,
                {
                    firstName,
                    lastName,
                    image
                }
            );
            if (response) {
                setTimeout(() => {
                    setIsLoading(false); // Hide the loading overlay
                    window.location.reload();
                }, 1000); // Display the overlay for 2 seconds
            }
        } catch (error) {
            console.error("Some Error in Fetching", error);
            setIsLoading(false); // Hide the loading overlay in case of error
        }
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
            setFileName(file.name);
            localStorage.setItem("fileName", file.name);
        }
    };

    return (
        <div className="relative">
            {isLoading && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <button disabled type="button" className="py-2.5 px-5 me-2 text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 inline-flex items-center">
                        <svg aria-hidden="true" role="status" className="inline w-4 h-4 me-3 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2"/>
                        </svg>
                        Changement en cours...
                    </button>
                </div>
            )}
            <div className="p-6 px-8">
                <h3 className="text-lg font-semibold text-bsrate">Mon compte</h3>
                <p className="text-slate-500">Vos informations personnelles</p>
                <div className="w-3/6">
                    <div className="col-span-full flex items-center gap-x-8 mt-6">
                        <div>
                            <input
                                type="file"
                                id="file-upload"
                                style={{ display: 'none' }}
                                onChange={handleFileUpload}
                            />
                            <label htmlFor="file-upload" className="btn btn-primary bg-bsrate text-white">
                                Choisir une image
                            </label>
                            <span className="ml-4 text-sm">(png, jpg ou jpeg - 5Mo max.)</span>
                        </div>
                    </div>
                    <div className="mt-6">
                        <label
                            htmlFor="first-name"
                            className="block text-sm font-medium leading-6 text-gray-900 mt-4"
                        >
                            Prénom
                        </label>
                        <div className="mt-1">
                            <input
                                type="text"
                                name="firstName"
                                id="firstName"
                                className="input w-full "
                                placeholder="Votre prénom"
                                onChange={(e) => setFirstName(e.target.value)}
                                value={firstName}
                            />
                        </div>
                        <label
                            htmlFor="last-name"
                            className="block text-sm font-medium leading-6 text-gray-900 mt-4"
                        >
                            Nom
                        </label>
                        <div className="mt-1">
                            <input
                                type="text"
                                name="lastName"
                                id="lastName"
                                className="input w-full "
                                placeholder="Votre nom"
                                onChange={(e) => setLastName(e.target.value)}
                                value={lastName}
                            />
                        </div>
                    </div>

                    <div className="mt-2">
                        <label
                            htmlFor="email"
                            className="block text-sm font-medium leading-6 text-gray-900 mt-4"
                        >
                            Email
                        </label>
                        <div className="mt-1">
                            <input
                                type="email"
                                name="email"
                                id="email"
                                className="py-3 px-5 rounded-lg w-full bg-white disabled "
                                placeholder="Votre adresse e-mail"
                                defaultValue={responseData?.email}
                                disabled
                            />
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn bg-bsrate hover:bg-black text-white mt-4 mb-1 "
                        onClick={updateUserDetails}
                    >
                        Mettre à jour
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AccountSettings;

